import { Alert, Button, HFlow, Icon, Modal, ModalBody, ModalFooter, ModalHeader, Tooltip, VFlow } from 'bold-ui'
import { alert } from 'components/alert'
import { Form, FormRenderProps, PecFormApi, SubmitButton, TextField } from 'components/form'
import { useAlterarTipoServicoMutation } from 'graphql/hooks.generated'
import { TipoServicoUpdateInput } from 'graphql/types.generated'
import { useMemo, useState } from 'react'
import { metaPath } from 'util/metaPath'
import { createValidator, maxLength, minLength, required } from 'util/validation'

import { TipoEstabelecimentoField } from '../create/TipoEstabelecimentoField'
import { TipoServicoItem } from '../TipoServicoTable'

export interface TipoServicoEditComponentProps {
  tipoServico: TipoServicoItem
  onEdit(): void
}

const validate = createValidator<TipoServicoUpdateInput>({
  nome: [required, minLength(3), maxLength(30)],
})

const path = metaPath<TipoServicoUpdateInput>()

export function TipoServicoEditComponent(props: Readonly<TipoServicoEditComponentProps>) {
  const { tipoServico, onEdit } = props

  const [open, setOpen] = useState(false)

  const [alterarTipoServico] = useAlterarTipoServicoMutation()

  const renderForm = (formProps: FormRenderProps<TipoServicoUpdateInput>) => {
    return (
      <Modal open={open} onClose={() => setOpen(false)} size='small'>
        <ModalHeader title='Editar tipo de serviço' />
        <ModalBody>
          <VFlow vSpacing={2}>
            <TextField name='nome' label='Nome do tipo de serviço' required />
            <TipoEstabelecimentoField name={path.tiposEstabelecimento} />
            {formProps.dirtyFields.tiposEstabelecimento && (
              <Alert type='info' inline styles={{ wrapper: { padding: '0.5rem' } }}>
                Ao salvar, o serviço será ativado ou inativado nos estabelecimentos conforme a seleção.
              </Alert>
            )}
          </VFlow>
        </ModalBody>
        <ModalFooter>
          <HFlow justifyContent='flex-end'>
            <Button onClick={handleCancel(formProps)}>Cancelar</Button>
            <SubmitButton kind='primary' handleSubmit={formProps.handleSubmit}>
              Salvar
            </SubmitButton>
          </HFlow>
        </ModalFooter>
      </Modal>
    )
  }

  const handleCancel = (formProps: FormRenderProps) => () => {
    setTimeout(formProps.form.reset)
    setOpen(false)
  }

  const handleSubmit = (values: TipoServicoUpdateInput, formApi: PecFormApi) => {
    return alterarTipoServico({ variables: { input: values } }).then(() => {
      alert('success', `Tipo de serviço ${values.nome.toUpperCase()} salvo com sucesso.`)
      setTimeout(formApi.reset)
      setOpen(false)
      onEdit()
    })
  }

  const initialValues = useMemo(
    () => ({
      id: tipoServico.id,
      nome: tipoServico.nome.toUpperCase(),
      tiposEstabelecimento: tipoServico.tiposEstabelecimento ?? [],
    }),
    [tipoServico.id, tipoServico.nome, tipoServico.tiposEstabelecimento]
  )

  return (
    <>
      <Tooltip text='Editar'>
        <Button size='small' skin='ghost' onClick={() => setOpen(true)}>
          <Icon icon='penOutline' />
        </Button>
      </Tooltip>
      <Form render={renderForm} onSubmit={handleSubmit} initialValues={initialValues} validate={validate} />
    </>
  )
}
